import React, { Component } from 'react';
import moment from 'moment';

import { dateRenderer, dateSorter } from './Helpers';
import UserModel from './UserModel';

import { Table, Popconfirm, Typography } from 'antd';

class FleximodoParkinglocationsTable extends Component {

  state = {
    children: []
  }

  columns = [{
    title: 'Lokalita',
    dataIndex: 'parkingLocationName',
    key: 'parkingLocationName',
    width: 350,
  }, {
    title: 'CarPark Code',
    dataIndex: 'carparkCode',
    key: 'carparkCode',
    width: 150,
  }, {
    title: 'Název posluchače',
    dataIndex: 'listenerName',
    key: 'listenerName',
  }, {
    title: 'Akce',
    key: 'Action',
    width: 100,
    render: (text, record) => {
      if (UserModel.isInRoles(['ADMIN', 'FLEXIMODO_LOCATIONS_WRITE'])) {
        return (
          <Popconfirm placement="right" title="Opravdu si přejete záznam smazat?" onConfirm={() => {
            this.props.onRemoveRow(record.carparkCode)
          }} okText="Ano" cancelText="Ne">
            <a onClick={(e) => { e.preventDefault(); }}><Typography.Text type="danger">Smazat</Typography.Text></a>
          </Popconfirm>
        );
      }
    },
  }]

  render() {
    return (
      <Table
        size='small'
        rowKey={this.props.rowKey ? this.props.rowKey : '_id'}
        loading={this.props.loading ? this.props.loading : false}
        columns={this.columns}
        dataSource={this.props.data}
        pagination={{
          showSizeChanger: true,
          defaultPageSize: localStorage.getItem('table_pageSize') !== undefined
            ? parseInt(localStorage.getItem('table_pageSize'))
            : 10,
          onShowSizeChange: (current, size) => {
            localStorage.setItem('table_pageSize', size);
          }
        }}
        style={{ border: '0px' }} />
    );
  }
}

export default FleximodoParkinglocationsTable;


// WEBPACK FOOTER //
// ./src/components/FleximodoParkinglocationsTable.js